/**
 * @param {Object} params
 * @param {any[]} [params.data=[]] - Optional response data (defaults to empty array)
 * @param {boolean} [params.success=true] - Optional success flag (defaults to true)
 */

/**
 * Creates a success response
 * @param {any} data - Required response data
 * @returns {any} - Returns the data directly
 */
export const CacheSuccess = (data) => {
    return data; // Return data directly
};

/**
 * Creates an empty response
 * @returns {null} - Returns null for empty/not found
 */
export const CacheEmpty = () => {
    return null; // Return null for empty response
}; 